// export const srArtContext = '/srArt/newsInfo'

export default [
  {
    path: `/newsInfo`,
    name: '新闻资讯',
    meta: {
      title: '新闻资讯-上饶美术馆',
    },
    component: () => import('../views/news/New.vue'),
  },
  {
    path: `/notice`,
    name: '通知公告',
    meta: {
      title: '通知公告-上饶美术馆',
    },
    component: () => import('../views/news/New.vue'),
  },
  {
    path: `/newsInfo/details`,
    name: '通知公告详请',
    meta: {
      title: '通知公告详请-上饶美术馆',
    },
    component: () => import('../views/news/News.vue'),
  },
  {
    path: `/medInfo`,
    name: '媒体报道',
    meta: {
      title: '媒体报道-上饶美术馆',
    },
    component: () => import('../views/news/Media.vue'),
  },
  {
    path: `/medInfo/details`,
    name: '媒体报道详请',
    meta: {
      title: '媒体报道详请-上饶美术馆',
    },
    component: () => import('../views/news/Medias.vue'),
  },
  {
    path: `/musInfo/details`,
    name: '馆内动态',
    meta: {
      title: '馆内动态详请-上饶美术馆',
    },
    component: () => import('../views/news/Museun.vue'),
  },
  {
    path: `/musInfo`,
    name: '馆内动态',
    meta: {
      title: '馆内动态-上饶美术馆',
    },
    component: () => import('../views/news/Museums.vue'),
  },
  
]

